
import { makeClassnames } from '../functions';

var FlagIcon = function FlagIcon(React, options, styles) {
  return function (props) {
    var _props$Component = props.Component,
        Component = _props$Component === undefined ? 'span' : _props$Component,
        children = props.children;

    return React.createElement(
      Component,
      { className: makeClassnames(props, options, styles) },
      children
    );
  };
};

export default FlagIcon;


//////////////////
// WEBPACK FOOTER
// /Users/leedongwei/Documents/Projects/crimp-application/node_modules/react-flag-icon-css/module/FlagIcon/FlagIcon.js
// module id = 692
// module chunks = 0